module.exports = __webpack_public_path__ + "static/posbank-28906951a5fc65a15a95e9cf4af3fa93.png";